<template>
<div class="chapter">
<div class="inner_page">
<p class="C317"><strong><span id="page_vii">Contents</span></strong></p>
<p class="P20"><a href="#/html/05_Acknowle#page_ix">Acknowledgments</a></p>
<p class="P21"><a href="#/html/06_Introduc#page_1">Introduction</a></p>
<p class="P21"><span class="small"><a href="#/html/07_CHAPTER#page_22">CHAPTER </a></span><a href="#/html/07_CHAPTER#page_22">1</a><a href="#/html/07_CHAPTER#page_22">. The Game</a></p>
<p class="P21"><span class="small"><span href="#/html/08_CHAPTER#page_42" title="Link target outside of Sample">CHAPTER </span></span><span href="#/html/08_CHAPTER#page_42" title="Link target outside of Sample">2</span><span href="#/html/08_CHAPTER#page_42" title="Link target outside of Sample">. Charlotte’s Web</span></p>
<p class="P21"><span class="small"><span href="#/html/09_CHAPTER#page_67" title="Link target outside of Sample">CHAPTER </span></span><span href="#/html/09_CHAPTER#page_67" title="Link target outside of Sample">3</span><span href="#/html/09_CHAPTER#page_67" title="Link target outside of Sample">. Broken Families</span></p>
<p class="P21"><span class="small"><span href="#/html/10_CHAPTER#page_84" title="Link target outside of Sample">CHAPTER </span></span><span href="#/html/10_CHAPTER#page_84" title="Link target outside of Sample">4</span><span href="#/html/10_CHAPTER#page_84" title="Link target outside of Sample">. Cutting the Head off the Snake</span></p>
<p class="P21"><span class="small"><span href="#/html/11_CHAPTER#page_110" title="Link target outside of Sample">CHAPTER </span></span><span href="#/html/11_CHAPTER#page_110" title="Link target outside of Sample">5</span><span href="#/html/11_CHAPTER#page_110" title="Link target outside of Sample">. The Prosecutor’s Darling</span></p>
<p class="P21"><span href="#/html/12_Conclusi#page_132" title="Link target outside of Sample">Conclusion: Fruit of the Poison Tree</span></p>
<p class="P21"><span href="#/html/13_Notes#page_143" title="Link target outside of Sample">Notes</span></p>
<p class="P21"><span href="#/html/14_Bibliogr#page_153" title="Link target outside of Sample">Bibliography</span></p>
<p class="P21"><span href="#/html/15_Index#page_161" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?4b45c8ab